import React, { useEffect, useRef, useState } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useHistory } from "react-router-dom";
import { loginRequest } from "../api/msalConfig";
import AuthAPI from "../api/Auth";
import { toast } from "react-toastify";

const MsalCallback = () => {
  const { instance, inProgress, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const history = useHistory();
  const handled = useRef(false);
  const [status, setStatus] = useState("Memproses login Microsoft...");
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) return;
    if (handled.current) return;

    handled.current = true;

    if (isAuthenticated && accounts.length > 0) {
      const account = accounts[0];
      console.log('----account')
      console.log(account)
      console.log('----account')
      // const account = accounts[0];
      // try {
      //   instance.acquireTokenSilent({ ...loginRequest, account }).then(async (tokenResponse) => {
      //         // localStorage.setItem("ms_account", JSON.stringify(account));
      //         // localStorage.setItem("ms_access_token", tokenResponse.accessToken);
      //         // localStorage.setItem("local_session", "true");
      //         // localStorage.setItem("session_time", Date.now().toString());
      //     setIsLoading(true);
      //     const body = new URLSearchParams({
      //       clientId: process.env.REACT_APP_APP_ID ?? "",
      //       idTokenEntra: tokenResponse.accessToken,
      //     });
      //     const res = await AuthAPI.login(body);
      //     if (res.status === 200) {
      //       setIsLoading(false);
      //       toast.error("Akun belum terverifikasi", {
      //         position: toast.POSITION.TOP_CENTER,
      //         theme: "colored",
      //       });
      //     }
      //   })
      // } catch (error) {
      //   console.error("Login error:", error);
      //   setIsLoading(false);
      // }
    } else {
      instance.loginRedirect(loginRequest);
    }
  }, [inProgress, isAuthenticated, accounts, instance]);

  return (
    <div>
      <h2>Microsoft OAuth</h2>
      <p>Status: {status}</p>
    </div>
  );
};

export default MsalCallback;